import { render } from "./Home.vue?vue&type=template&id=5caead14&scoped=true&bindings={\"scroll\":\"options\",\"pathChevron\":\"data\",\"pathWhats\":\"data\",\"pathFacebook\":\"data\",\"pathInstagram\":\"data\",\"pathEmail\":\"data\"}"
import script from "./Home.vue?vue&type=script&lang=js"
export * from "./Home.vue?vue&type=script&lang=js"

import "./Home.vue?vue&type=style&index=0&id=5caead14&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-5caead14"

export default script